(() => {
  const roots = document.querySelectorAll('[data-lsc]:not([data-lsc-ready])');
  if (!roots.length || !('IntersectionObserver' in window)) return;

  let loading = null;
  const loadGsap = (src) => {
    if (window.gsap) return Promise.resolve(window.gsap);
    if (window.lsLoadGsap) return window.lsLoadGsap(src);
    if (!loading) {
      loading = new Promise((resolve, reject) => {
        const tag = document.createElement('script');
        tag.src = src;
        tag.async = true;
        tag.onload = () => (window.gsap ? resolve(window.gsap) : reject());
        tag.onerror = reject;
        document.head.appendChild(tag);
      });
    }
    return loading;
  };

  const offscreen = (el) => {
    const r = el.getBoundingClientRect();
    return r.top > window.innerHeight || r.bottom < 0;
  };

  roots.forEach((root) => {
    root.dataset.lscReady = '';
    const reveal = root.querySelectorAll('[data-lsc-reveal]');
    const items = root.querySelectorAll('[data-lsc-item]');
    const feature = root.querySelector('[data-lsc-feature]');
    const media = feature && feature.querySelector('.lsc-feature__media');
    const img = feature && feature.querySelector('.lsc-feature__img');
    const body = feature && feature.querySelector('.lsc-feature__body');

    const near = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      near.disconnect();
      loadGsap(root.dataset.gsapSrc).then((gsap) => {
        // Only hide content that is still offscreen; anything already visible stays put.
        if (!offscreen(root)) return;
        const mm = gsap.matchMedia();
        mm.add('(prefers-reduced-motion: no-preference)', () => {
          gsap.set(reveal, { autoAlpha: 0, y: 18 });
          gsap.set(items, { autoAlpha: 0, y: 14 });
          if (media) gsap.set(media, { clipPath: 'inset(0% 0% 100% 0% round 16px)' });
          if (img) gsap.set(img, { scale: 1.12 });
          if (body) gsap.set(body, { autoAlpha: 0, y: 14 });

          const tl = gsap.timeline({ paused: true, defaults: { ease: 'power3.out', duration: 0.7 } });
          tl.to(reveal, { autoAlpha: 1, y: 0, stagger: 0.07 }, 0);
          if (media) tl.to(media, { clipPath: 'inset(0% 0% 0% 0% round 16px)', duration: 1, ease: 'expo.out' }, 0.1);
          if (img) tl.to(img, { scale: 1, duration: 1.3, ease: 'expo.out', clearProps: 'transform' }, 0.1);
          if (body) tl.to(body, { autoAlpha: 1, y: 0 }, 0.35);
          tl.to(items, { autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.045, clearProps: 'transform,opacity,visibility' }, 0.2);
          if (media) tl.set(media, { clearProps: 'clipPath' });

          const enter = new IntersectionObserver((entries) => {
            if (!entries.some((e) => e.isIntersecting)) return;
            enter.disconnect();
            tl.play();
          }, { rootMargin: '0px 0px -12% 0px' });
          enter.observe(root);

          return () => { enter.disconnect(); tl.kill(); };
        });
      }).catch(() => {});
    }, { rootMargin: '600px 0px' });
    near.observe(root);
  });
})();
